import { render, staticRenderFns } from "./security-register.layout.vue?vue&type=template&id=2b050b1d"
import script from "./security-register.layout.ts?vue&type=script&lang=ts&external"
export * from "./security-register.layout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports